import { createActionRequestTypes } from "../utils/utils";

export default {
    ...createActionRequestTypes("USERS/LOGIN"),
    ...createActionRequestTypes("USERS/LOGOUT"),
    ...createActionRequestTypes("VALIDATIONS/CREATE"),
    ...createActionRequestTypes("VALIDATIONS/LIST"),
    ...createActionRequestTypes("COUPONS/CREATE"),
    ...createActionRequestTypes("COUPONS/LIST"),
};